import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { ClipboardService } from '../../../services/clipboard/clipboard.service';

@Component({
  selector: 'app-copy-to-excel-button',
  standalone: true,
  imports: [MatIconModule, RouterModule],
  templateUrl: './copy-to-excel-button.component.html',
  styleUrls: ['./copy-to-excel-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyToExcelButtonComponent {
  @Input() gridApi!: GridApi;

  constructor(private readonly clipboardService: ClipboardService) {}

  copyToClipboard() {
    this.clipboardService.copyToClipboardFromGridApi(this.gridApi);
  }
}
